import React, { useEffect } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { Navbar2 } from "../common";
import images from "../constants/images";
import {
  injectOfficialPapSaleSnippet,
  loadThankYouOrderSnapshot,
  clearThankYouOrderSnapshot,
} from "../utils/postAffiliatePro";
import { pushPurchase } from "../utils/ecommerceDataLayer";

const SucessPage = () => {
  const location = useLocation();
  const saved = loadThankYouOrderSnapshot() || {};
  const orderId = location.state?.orderId ?? saved.orderId;
  const orderIds =
    location.state?.orderIds ||
    saved.orderIds ||
    [orderId].filter(Boolean);
  const productTotal =
    location.state?.productTotal ?? saved.productTotal ?? 0;
  const productId = location.state?.productId ?? saved.productId ?? "";

  const currentDomain = window.location.hostname;
  let memberPortalUrl = "https://member.ignite-rx.com/";
  if (currentDomain === "checkout.ignite-rx.com") {
    memberPortalUrl = "https://member.ignite-rx.com/";
  } else if (currentDomain === "checkoutdev-igniterx.wlmd.dev") {
    memberPortalUrl = "https://mpdev-igniterx.wlmd.dev/";
  }

  /**
   * PAP General solution — thank-you / order confirmation sale tracking.
   */
  useEffect(() => {
    const primaryOrderId = (orderIds && orderIds[0]) || orderId;
    if (!primaryOrderId) {
      console.warn("[PAP] thank-you: no orderId — sale not registered");
      return;
    }

    const total =
      productTotal != null && productTotal !== ""
        ? String(productTotal)
        : "0";
    const pid = productId ? String(productId) : String(primaryOrderId);

    const ids = String(pid)
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean);
    const share =
      ids.length > 0
        ? (parseFloat(total) / ids.length || 0).toFixed(2)
        : total;
    const products = (ids.length ? ids : [String(primaryOrderId)]).map(
      (id) => ({
        product_id: id,
        product_name: id,
        product_price: share,
      })
    );

    pushPurchase({
      products,
      transactionId: String(primaryOrderId),
      value: total,
    });

    const t = setTimeout(() => {
      const ok = injectOfficialPapSaleSnippet({
        orderId: String(primaryOrderId),
        totalCost: total,
        productId: pid,
      });
      if (ok) clearThankYouOrderSnapshot();
      else console.warn("[PAP] thank-you: General solution sale snippet failed");
    }, 400);

    return () => clearTimeout(t);
  }, [orderId, orderIds, productTotal, productId]);

  return (
    <>
      <Navbar2 color="#fff" logo={images.logo} />
      <Wrapper className="page-100" style={{ background: "white" }}>
        <section>
          <h1 className="h3_in_mobile" style={{ color: "black" }}>
            Thank You
          </h1>
          <h3
            style={{
              display: "block",
              textAlign: "center",
              width: "70%",
              margin: "2rem auto",
              minWidth: "300px",
            }}
          >
            Thank you for placing your purchase order with us! We are grateful
            for your business and excited to assist you. To ensure a smooth and
            efficient process, please complete the intake form available in your
            member portal at your earliest convenience.
          </h3>
          <h3
            style={{
              display: "block",
              textAlign: "center",
              width: "70%",
              margin: "2rem auto",
              minWidth: "300px",
              color: "#000",
              fontSize: "1.2rem",
            }}
          >
            (Your credentials have been sent to the email address you provided.
            Please check your inbox for further instructions.)
          </h3>
          <a
            href={memberPortalUrl}
            className="product-button"
            style={{ marginTop: "2rem" }}
          >
            Go to Member Portal
          </a>
        </section>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.main`
  background: #ffefba;
  background: -webkit-linear-gradient(to right, #ffefba, #ffffff);
  background: linear-gradient(to right, #ffefba, #ffffff);

  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 90vh;
  h1 {
    font-size: 10rem;
    font-weight: 700;
  }
  h3 {
    text-transform: none;
    margin-bottom: 2rem;
  }
  .h3_in_mobile {
    font-size: 9rem;
  }

  @media screen and (max-width: 720px) {
    h1 {
      font-size: 4rem;
    }
    .h3_in_mobile {
      font-size: 5rem;
    }
  }
`;

export default SucessPage;
